export default "__VITE_ASSET__e36d741d__"